import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SHARE_VISUALS = defineFcm('starfish_share_visuals')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				locales: { type: 'array', shape: { type: 'enum', values: getLocales() } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-front-end', 'monorail'],
		context: 'Petition share visuals',
		description: `Feature release flag that enables share visuals for petitions.
		The petition service only uses the "enabled" value for determining whether to start creating share visuals for petitions,
		while the frontend uses both "enabled" and the users "locale" to determine whether to show the UI.`,
		template: {
			enabled: true,
			locales: ['en-US'],
		},
	});
